import React from 'react';
import { Root } from './styled.js';

const Overflow = ({ className, items, render, overflown, }) => {
    return (React.createElement(Root, { prefixCls: 'tend-ui-overflow', className: className, maxCount: 'responsive', data: items, renderItem: render, renderRest: overflown }));
};
Overflow.displayName = 'Overflow';

export { Overflow };
//# sourceMappingURL=Overflow.js.map
